import { type SvgIconProps } from '@mui/material';
import React from 'react';

function DocumentIcon(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="28"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V13.5H10.5V3L6.75 0H0ZM8.25 4.875H2.25V6H8.25V4.875ZM8.25 7.125H2.25V8.25H8.25V7.125ZM2.25 9.375H8.25V10.5H2.25V9.375Z"
        fill="#232729"
      />
    </svg>
  );
}

export default DocumentIcon;
